export const SET_STATUS = 'SET_STATUS'
// export const CLEAR_STATE = 'CLEAR_STATE'
export const SET_SNACKBAR = 'SET_SNACKBAR'
export const CLEAR_SNACKBAR = 'CLEAR_SNACKBAR'
export const GET_USERNAME = 'GET_USERNAME'
